import * as React from "react"
import {Component} from "react"
import styles from "./InputPhone.module.css"
import Input, {getCountries, getCountryCallingCode} from "react-phone-number-input/input"
import en from "react-phone-number-input"
import {getPartsByDelimiter, INPUT_PHONE_DEFAULT_OPTIONS} from "lib/functions/helper"

interface Props {
    id: string
    inputCountryId: string
    json_data: any
    onChange: (id, value) => void
    type?: "text" | "tel" | "email"
    disabled?: boolean
    placeholder?
    pattern?: string
    classNameWrap?: string
    className?: string
    defaultCountry?: string
}

const CountrySelectInput = ({value, onChange, labels, ...rest}) => (
    <div className={styles.flagIcon}>
        {/* {console.log('@@@@@ value:', value)} */}
        {/* {!value ? (
            <International />
        ) : (
            <img
                className={styles.countryFlag}
                alt={value}
                src={`https://purecatamphetamine.github.io/country-flag-icons/3x2/${value}.svg`}
            />
        )} */}
        <select
            className={styles.flagIconCountrySelect}
            {...rest}
            value={value}
            onChange={(event) => {
                const newValue: any = event.target.value
                onChange(newValue)
            }}>
            <option value="">{labels["ZZ"]}</option>
            {getCountries().map((country) => (
                <option key={country} value={country}>
                    {labels[country]}
                </option>
            ))}
        </select>
        <div>
            <img
                className={styles.countryFlag}
                alt={value}
                src={`https://purecatamphetamine.github.io/country-flag-icons/3x2/${value}.svg`}
            />
        </div>
        <div className={styles.arrow}></div>
    </div>
)

export class InputPhone extends Component<Props, {}> {
    private value

    private defultCountry
    private countryCodeSelected

    public static defaultProps = {
        type: "text",
        errors: {}
    }

    handleChange(evt) {
        this.value = evt.target.validity.valid ? evt.target.value : this.value
    }

    getDefaultCountry(country: string) {
        // console.log("@@@@@@ country:", country)
        if (!country || typeof country === "number") {
            return ""
        }
        const [, , , code] = getPartsByDelimiter(country)
        if (!code) {
            return ""
        }
        return code
    }

    onFocusTextAtEnd(event: any) {
        const current: any = event.target.value
        event.target.value = ""
        event.target.value = current
    }

    public render() {
        const {
            id,
            onChange,
            json_data,
            inputCountryId,
            className,
            classNameWrap,
            defaultCountry
        } = this.props
        const {defaultCountries, maxLength} = INPUT_PHONE_DEFAULT_OPTIONS
        this.value = json_data[id] || ""
        // const error = errors[id]
        this.defultCountry = this.getDefaultCountry(json_data[inputCountryId])
        this.countryCodeSelected = !json_data[`${inputCountryId}_code`]
            ? !this.defultCountry
                ? defaultCountry
                : this.defultCountry
            : json_data[`${inputCountryId}_code`]
        // console.log('@@@@@@ countryCodeSelected:', this.countryCodeSelected, json_data[`${inputCountryId}_code`])

        let css = `${styles.root} ${className}`
        // if (error) {
        //     css = `${css} ${styles.rootError}`
        // }

        return (
            <div className={classNameWrap} id={id}>
                <div className={styles.inputCountryCodeWrap}>
                    <CountrySelectInput
                        labels={en.defaultProps.labels}
                        value={this.countryCodeSelected}
                        onChange={(newCountryCode) => {
                            json_data[
                                `${inputCountryId}_code`
                            ] = this.countryCodeSelected = newCountryCode
                            delete json_data[id]
                            this.forceUpdate()
                        }}
                    />
                    <div className={styles.countryCode}>
                        <span>
                            {`+ ${
                                !this.countryCodeSelected
                                    ? "1"
                                    : getCountryCallingCode(this.countryCodeSelected)
                            }`}
                        </span>
                    </div>
                    <Input
                        international
                        defaultCountry={this.countryCodeSelected}
                        placeholder="Enter phone #"
                        value={this.value}
                        onChange={(value) => {
                            console.log("@@@@ phone value:", id, value)
                            onChange(id, value)
                        }}
                        maxLength={
                            !this.countryCodeSelected
                                ? maxLength.other
                                : this.countryCodeSelected === defaultCountries.us.code
                                ? maxLength.us
                                : maxLength.other
                        }
                        autoComplete="off"
                    />
                </div>
                {/* {error && <p className={styles.error}>{error} </p>} */}
            </div>
        )
    }
}
